import { Loader, Stack } from "@mantine/core";

export function LoadingScreen() {
  return (
    <Stack h="100vh" justify="center" align="center">
      <Loader size="xl" color="primary.7" />
    </Stack>
  );
}
